import { format } from 'date-fns';
import { DMY_FORMAT } from '../constants/dateFormats';

export function scrollToFinalChatItem(cssQuery = '.messageContainerAnchor') {
  setTimeout(() => {
    try {
      const messageElements = document.querySelectorAll(cssQuery);
      const lastMessage = messageElements[messageElements.length - 1];
      lastMessage.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    } catch (error) {
      console.error(`could not scroll into view for query '${cssQuery}'`);
    }
  }, 300);
}

export function addItemToHistoryChat(prompt, history) {
  const formattedDate = format(new Date(prompt.createdAt), DMY_FORMAT);
  if (history[formattedDate]) {
    history[formattedDate].push(prompt);
  } else {
    history[formattedDate] = [prompt];
  }
}
